'use es6';

import { useMemo } from 'react';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
const LegalConsentOptions = ['NONE', 'IMPLICIT_CONSENT', 'SEPERATE_CONSENT', 'LEGITIMATE_INTEREST'];
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.gdprSelect.${key}`;
const getFormatOptions = () => LegalConsentOptions.map(key => ({
  text: text(i18nKey(`options.${key}.text`)),
  help: /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey(`options.${key}.help`)
  }),
  value: key
}));
const Select = ({
  value,
  useOnDark,
  onChange,
  disabled,
  options,
  readOnly
}) => /*#__PURE__*/_jsx(UISelect, {
  "data-selenium": "form-gdpr-select",
  defaultValue: LegalConsentOptions[0],
  value: value,
  onChange: ({
    target: {
      value: newValue
    }
  }) => onChange(newValue),
  options: options,
  disabled: disabled,
  buttonUse: useOnDark ? 'form-on-dark' : 'form',
  readOnly: readOnly
});
const GDPRSelect = ({
  value = '',
  onChange = () => {},
  disabled = false,
  useOnDark = false,
  readOnly = false
}) => {
  const formattedOptions = useMemo(() => getFormatOptions(), []);
  return /*#__PURE__*/_jsx(Select, {
    value: value,
    useOnDark: useOnDark,
    onChange: onChange,
    options: formattedOptions,
    disabled: disabled,
    readOnly: readOnly
  });
};
GDPRSelect.propTypes = {
  value: PropTypes.oneOf(LegalConsentOptions),
  useOnDark: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};
export default GDPRSelect;